/***************** General Page Stuff ******************/

// Wait timer
$.wait = function( callback, seconds){
   return window.setTimeout( callback, seconds * 1000 );
}

function isMobile() {
  if (navigator.userAgent.match(/(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/)) $('body').addClass('mobile');
}


function contentBottomMargin() {
  if ($('.footer').length && !$('body').hasClass('home') && Foundation.MediaQuery.atLeast('mediumx')) {
    var contentElem = $('#content:after');
    var pageFooterHeight = $('.footer').outerHeight();
    console.log('pageFooterHeight: ' + pageFooterHeight);
    //contentElem.css('height',pageFooterHeight + 'px');
    $('#js-generated-css').remove()
    $('head').append('<style id="js-generated-css">#inner-content {margin-bottom: ' + pageFooterHeight + 'px; }</script>');
    //alert ('pageFooterHeight:' + pageFooterHeight);
  } else {
    $('#js-generated-css').remove();
    $('head').append('<style id="js-generated-css">#inner-content {margin-bottom: 0; }</script>');
  }
}

/***************** Ken Burns Init ******************/

function initKenBurns() {
  if ($('div[data-row-bg-animation="ken_burns"]').length) {
    $('div[data-row-bg-animation="ken_burns"]').find('.row-bg').addClass('kenburns');
  }
}

/***************** Set opacity of footer contact slide-up ******************/
var topOffset;
function footerContactReveal() {
  var footerOuter = $('#footer-outer');
  var footerInner = $('.footer-inner');
  var footerContactWrapper = $('#contact-wrapper');
  var footerContactReveal = $('#contact-reveal');
  if (Foundation.MediaQuery.atLeast('mediumx')) {
    topOffset = 20;
  } else {
    topOffset = 0;
  }
  if (!footerOuter.hasClass('revealing')) { // If not already animating
    if (!footerOuter.hasClass('revealed')) { // If not already revealed
      $('body').addClass('footer-contact-opening');
      footerOuter.addClass('revealed');
      footerOuter.addClass('revealing');
      footerContactReveal.css('display','block');
      footerInner.animate(
        {
          borderSpacing: '0',
        },
        {
          duration: 150,
          step: function(now,fx) {
          //  footerOuter.css('transform','translateY(-5%)');
          },
          complete:function() {
            // Animation complete
            console.log('next step');
            footerOuter.animate(
              {
                top: topOffset,
              },
              {
              duration: 1000,
              step: function(now,fx) {
                footerOuter.css('transform','translateY(0)');
              //  footerOuter.css({'transform','translateY(0)'});
              //  footerOuter.css('transform','translateY(0)');
                //footerContactWrapper.css('max-height','9000px');
                //
              },
              complete: function() {
                // Animation complete
                footerInner.css('transform','translateY(200%)');
                footerContactReveal.css('opacity','1');
                footerContactWrapper.css('max-height','9999px');
                footerOuter.removeClass('revealing');
                $('body').addClass('footer-contact-open');
                $('body').removeClass('footer-contact-opening');
                $('#footer-contact-toggler').addClass('make-cross');
              }
            });
          }
        });
    } else {
      $('body').removeClass('footer-contact-open');
      $('body').addClass('footer-contact-opening');
      window.scrollTo(0,document.body.scrollHeight);
      footerOuter.addClass('revealing');
      footerContactReveal.css('opacity','0');

      footerOuter.animate(
        {
          top: '100%',
        },
        {
        duration: 1000,
        step: function(now,fx) {
          //footerContactReveal.css('display','none');
          footerOuter.css('transform','translateY(-15%)');
          footerContactWrapper.css('max-height','100px');
        //  footerOuter.css({'transform','translateY(0)'});
        //  footerOuter.css('transform','translateY(0)');

          //footerContactReveal.css('max-height','100%');
        },
        complete: function() {
          // Animation complete

          footerInner.animate(
            {
              borderSpacing: '1',
            },
            {
            duration: 500,
            step: function(now,fx) {
              footerInner.css('transform','translateY(0)');
              footerOuter.css('transform','translateY(-100%)');
              //footerContactReveal.css('max-height','100%');
            },
            complete: function() {
              // Animation complete
              footerOuter.removeClass('revealing');
              footerOuter.removeClass('revealed');
              $('body').removeClass('footer-contact-opening');
              $('#footer-contact-toggler').removeClass('make-cross');
            //  footerOuter.css('transform','translateY(-100%)');
            }
          });
        }
      });
    }
  }
}



/***************** Homepage Fullpage Slides Init ******************/
var st = 0,
fixThreshold = 4,
numberOfItems = $('.fullpage .section').length;
var next_slide_midnight;
function initHomeSlides() {
  if ($('body.home').length && Foundation.MediaQuery.atLeast('xlarge')) {
    var scrollOverflowActive = false;
    /*if () {
      console.log('at least medium');
    } else {
      var scrollOverflowActive = true;
      console.log('smaller than medium');
    }*/

    console.log('initHomeSlides');
    $('.fullpage').fullpage({
				anchors: ['welcome', 'introduction', 'whatwedo','portfolio','footer'],
				//sectionsColor: ['#C63D0F', '#1BBC9B', '#7E8F7C'],
        navigation: true,
        paddingTop: 0,
        paddingBottom: 0,
        navigationPosition: 'right',
        navigationTooltips: ['Welcome', 'Introduction','What We Do','Portfolio'],
				scrollBar: true,
        scrollOverflow: scrollOverflowActive,
        /*afterLoad: function(anchorLink, index, slideAnchor, slideIndex){
          if($('.fullpage').hasClass('afterLoaded')) {
            var $row_id = $('.fullpage > .section:nth-child('+index+')').attr('id');
            if($row_id !='footer-outer') {
  						$('.fullpage > .section.last-before-footer').css('transform','initial');
  						//$('.fullpage > .section').css('transform','initial').removeClass('last-before-footer');
            }
          } else {
            $('.fullpage').addClass('afterLoaded');
            //for users that have scrolled down prior to turning on full page
			       setTimeout(function(){ window.scrollTo(0,0); },1800);
          }
        },*/
        onLeave: function(origin, destination, direction){
          console.log('index: ' + destination.nextIndex);
            next_slide_midnight = $('.section').eq(destination.index).attr('data-midnight');
           console.log('next_slide_midnight: ' + next_slide_midnight);
            if (typeof(next_slide_midnight) != "undefined" && next_slide_midnight !== null) {
              $('body').attr('data-midnight-type',next_slide_midnight);
            } else {
              $('body').attr('data-midnight-type','default');
            }
            /*// Fixed Footer Stuff
            var $row_id = $('.fullpage > .section:nth-child('+nextIndex+')').attr('id');
	        	var $indexRow = $('.fullpage > .section:nth-child('+index+')');
	        	var $nextIndexRow = $('.fullpage > .section:nth-child('+nextIndex+')');
	        	var $nextIndexRowInner = $nextIndexRow.find('.full-page-inner-wrap-outer');
	        	var $nextIndexRowFpTable = $nextIndexRow.find('.fp-tableCell');
            var $transformProp = (!navigator.userAgent.match(/(Android|iPod|iPhone|iPad|BlackBerry|IEMobile|Opera Mini)/)) ? 'transform' : 'all';
            var $fpAnimation = 'parallax';
            var $fpAnimationSpeed = 850;
            if( $row_id == 'footer-outer') {
	        		$indexRow.addClass('last-before-footer');
	        		$('#footer-outer').css('opacity','1');
	        	} else {
	        		$('.fullpage > .section.last-before-footer').css('transform','translateY(0px)');
	        		//$('#footer-outer').css('opacity','0');
	        	}
	        	if($indexRow.attr('id') == 'footer-outer') {
	        		$('#footer-outer').css({'transition': $transformProp+' 460ms cubic-bezier(0.60, 0.23, 0.2, 0.93)', 'backface-visibility': 'hidden'});
	        		$('#footer-outer').css({'transform': 'translateY(45%) translateZ(0)'});
	        	}
            setTimeout(function() {

	        		if( $row_id == 'footer-outer') {

		        		$indexRow.css('transform','translateY(-'+($('#footer-outer').height()-1)+'px)');

		        		$('#footer-outer').css({'transform': 'translateY(45%) translateZ(0)'});
		        		$('#footer-outer').css({'transition-duration': '0s', 'backface-visibility': 'hidden'});
		        		setTimeout(function() {
		        			$('#footer-outer').css({'transition': $transformProp+' 500ms cubic-bezier(0.60, 0.23, 0.2, 0.93)', 'backface-visibility': 'hidden'});
	        				$('#footer-outer').css({'transform': 'translateY(0%) translateZ(0)'});
	        			},30);
		        	}
	        	},30);*/
        },

			});
  } else if ($('body.home').length) {

  }
}

/***************** Smoothscroll Init ******************/

function initSmoothScroll() {
  var $smoothActive = $('body').attr('data-smooth-scrolling');
  var $smoothCache = ($smoothActive == 1) ? true : false;
  if ($smoothActive == 1 && $(window).width() > 690 && $('body').outerHeight(true) > $(window).height() && !navigator.userAgent.match(/(Android|iPod|iPhone|iPad|IEMobile|Opera Mini|Macintosh)/)) {
      niceScrollInit();
  } else {
      $('body').attr('data-smooth-scrolling', '0');
  }
}

function niceScrollInit() {
    $("html").niceScroll({
        scrollspeed: 60,
        mousescrollstep: 40,
        cursorwidth: 15,
        cursorborder: 0,
        cursorcolor: '#303030',
        cursorborderradius: 6,
        autohidemode: false,
        horizrailenabled: false
    });
    if ($('#boxed').length == 0) {
        $('body').css('padding-right', '16px');
    } else if ($('body[data-ext-responsive="true"]').length == 0) {
        $('body').css('padding-right', '16px');
    }
    if ($('.sticky-container.absolute-position').length) {
      $('.sticky-container.absolute-position .sticky').addClass('no-max-width');
    }
    $('html').addClass('no-overflow-y');
}



/***************** Init mouse movement effects ******************/

function calcWindowHeight() {
  var windowHeight = $(window).height();
  if (Foundation.MediaQuery.atLeast('xlarge')) {
    // Do nothing
  } else {
    $('.calc-height-medium-down').css('height',windowHeight+'px');
  }
}
/***************** Init mouse movement effects ******************/

function mouseMovement() {
  var parentWidth = $(".mouse-movement").width();
  var parentHeight = $(".mouse-movement").height();
  //console.log('parentHeight' + parentHeight);
  var elemExtraWidth = parentWidth*0.1;
  var elemExtraHeight = parentHeight*0.1;
  //console.log('elemExtraHeight' + elemExtraHeight);
  var leftMargin = '-'+elemExtraWidth+'px';
  var topMargin = '-'+elemExtraHeight+'px';
  //console.log('leftMargin' + leftMargin);
  //console.log('topMargin' + topMargin);
  var elemWidth = parentWidth + (elemExtraWidth*2);
  var elemHeight = parentHeight + (elemExtraHeight*2);
  //console.log('elemWidth' + elemWidth);
  $(".mouse-movement").interactive_bg({
   strength: 15,
   scale: 1,
   animationSpeed: "100ms",
   contain: true,
   wrapContent: false
 });
 $(".mouse-movement > .ibg-bg").css({
   'width': elemWidth,
   'height': elemHeight,
   'margin-top': topMargin,
   'margin-left': leftMargin
 });
}



/***************** Init wow.js ******************/

function indigo_init_wow() {
  // Must use wow= rather than var wow= to ensure it is accessible outside of function!
  wow = new WOW({
    boxClass: 'wow',
    animateClass: 'active'
  });

  wow.init();
}

/***************** Show message if applicable ******************/

function showMsg() {
  var msgContent = getUrlParameter('msg');
  if (typeof(msgContent) != "undefined" && msgContent !== null) {
    $('#msg-content').html(decodeURIComponent(msgContent));
    $('body').addClass('is-msg-open');
    $('#msg-modal').foundation('open');
    setTimeout( function() {
      $('#msg-modal').foundation('close');
      $('body').removeClass('is-msg-open');
      removeParam('msg');
    }, 2500);
  }
}



/***************** Init Maps ******************/

function indigo_init_maps() {
  // Must use wow= rather than var wow= to ensure it is accessible outside of function!
  $('.map-wrapper').each(function(index) {
    var this_height = $(this).height();
    var element_id = $(this).find('.map').attr('id');
    var data_lat = $(this).data('lat');
    var data_long = $(this).data('long');
  //  $(this).find('.map').css('height',this_height + 'px');
    indigo_run_map_google_map(element_id,data_lat,data_long,map_zoom);
  });
}


/***************** Masonry Filtering stuff ******************/

function masonryFilter(the_filter) {
  //$('#product-info').on('replaced.zf.interchange', function(){
  if ($('.masonry').length && the_filter!='' && the_filter!='*') {
    $('.masonry-item').not('[data-category="'+ the_filter +'"]').hide();
    $('.masonry-item[data-category="'+ the_filter +'"]').show();
    updateParam('filter',the_filter);
    //then update wow for elements that have now come into view
    if (typeof wow !== 'undefined') {
      wow.scrolled = true;
      wow.scrollCallback();
    }
  } else if ($('.masonry').length && the_filter=='*') {
    $('.masonry-item').show();
    removeParam('filter');
    //then update wow for elements that have now come into view
    if (typeof wow !== 'undefined') {
      wow.scrolled = true;
      wow.scrollCallback();
    }
  }
}

function filterChange() {
  $('.masonry-filter').on('change',function() {
    var the_filter = $(this).find('option:selected').val();
    masonryFilter(the_filter);
  });
}

function filterUrlVar() {
  var url_filter = getUrlParameter('filter');
  if (url_filter!='' && typeof url_filter != 'undefined') {
    masonryFilter(url_filter);
  }
}



/***************** Panel Slider Init ******************/

function pagePanelSliderInit () {
  if ($('.page-panel-slider').length) {
    Foundation.onImagesLoaded($('.page-panel-slider img.wait-for-me'), function(){
      ////console.log('images loaded');
      var pagePanelSlider = $('.page-panel-slider').flickity({
        // options
        cellAlign: 'left',
        //cellSelector: '.product-image-slide',
        prevNextButtons: true,
        imagesLoaded: true,
        contain: true,
        wrapAround: true,
        //setGallerySize: false,
        autoPlay: false
      });
      //var productImageSlider = $('#product-image-slider').flickity();
      pagePanelSlider.flickity('resize');
      //$('html').getNiceScroll().resize();
    });
  }
}

jQuery(document).ready(function($) {
    isMobile();
    initHomeSlides();
    initKenBurns();
    calcWindowHeight();
    indigo_init_wow();
    contentBottomMargin();
    indigo_init_maps();
    showMsg();
    //Initiate Midnight
    if ($('body.home').length) {
      $('#header-outer').midnight();
    }

    $('#footer-contact-toggler').on('click',function() {
      footerContactReveal();
    });

    /***************** Submit header search form ******************/

    $('#filter-submit').on('click',function(e) {
      e.preventDefault();
      $('form#investment-filter-form').submit();
    });

    $('form#investment-filter-form').submit(function(e){
      $(this).find('input').filter(function(){
             return !this.value;
      }).remove();
    })

    /***************** Submit header search form ******************/

    $('#inpage-search-input').on('keyup',function(e) {
      $('#header-search-input').val($(this).val());
      if(e.keyCode == 13){
        $('form#header-search-form').submit();
      }
    });

    $('#inpage-search-submit').on('click',function(e) {
      e.preventDefault();
      $('form#header-search-form').submit();
    });

    /***************** Small Search Form ******************/


    $('#small-search-input').on('keyup',function(e) {
      $('#header-search-input').val($(this).val());
      if(e.keyCode == 13){
        $('form#header-search-form').submit();
      }
    });


  // On scroll
  $(window).scroll(function() {

  });
	$(window).resize(function(){
    contentBottomMargin();
    calcWindowHeight();
    wow.scrolled = true;
    wow.scrollCallback();
  });
});
